import React from 'react';
import { Question } from 'types/questionnaire/types';

interface ChoiceQuestionProps {
  question: Question;
  value: string | null | undefined;
  onChange: (value: string) => void;
  error?: string;
}

const ChoiceQuestion: React.FC<ChoiceQuestionProps> = ({ question, value, onChange, error }) => {
  const choiceA = question.choiceALabel || 'Option A';
  const choiceB = question.choiceBLabel || 'Option B';

  return (
    <fieldset className="flex flex-col gap-4">
      <legend className="text-lg font-semibold leading-7 tracking-tight text-brand-black mb-5">{question.text}</legend>
      {question.description && <p className="text-sm text-brand-black/80">{question.description}</p>}
      {question.content && question.content.length > 0 && (
        <ul className="list-disc pl-5 text-sm text-brand-black/80">
          {question.content.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
      <div className="flex flex-col gap-3">
        <button
          type="button"
          className={`w-full rounded-lg border px-4 py-2 text-left text-base font-normal leading-6 tracking-[-0.44px] text-brand-black transition-colors ${
            value === 'A'
              ? 'border-talo-dark-green bg-talo-dark-green text-white'
              : 'questionnaire-answer-option border-gray-300 bg-white text-brand-black'
          }`}
          onClick={() => onChange('A')}
        >
          {choiceA}
        </button>
        <button
          type="button"
          className={`w-full rounded-lg border px-4 py-2 text-left text-base font-normal leading-6 tracking-[-0.44px] text-brand-black transition-colors ${
            value === 'B'
              ? 'border-talo-dark-green bg-talo-dark-green text-white'
              : 'questionnaire-answer-option border-gray-300 bg-white text-brand-black'
          }`}
          onClick={() => onChange('B')}
        >
          {choiceB}
        </button>
      </div>
      {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
    </fieldset>
  );
};

export default ChoiceQuestion;
